import { Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { RSFResourceTypesSetting, RSFRoleNotificationSetting, RSFSettings, RSFSettingType } from '../rsf-settings';
import { BaseComponent } from 'src/app/common/base/base.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';
import { ResourceType } from 'src/app/components/catalogs/beamline-catalog/resource/resources';

@Component({
  selector: 'rsf-settings-resource-types',
  templateUrl: './rsf-settings-resource-types.component.html',
  styleUrls: ['./rsf-settings-resource-types.component.scss']
})
export class RsfSettingsResourceTypesComponent extends BaseComponent implements OnChanges {

  @Input() rsfSettings?: RSFSettings[];
  @Output() changed = new EventEmitter<RSFSettings[]>();

  resourceTypesSettings?: RSFResourceTypesSetting[] = [];
  tmpResourceTypeSetting?: RSFResourceTypesSetting | null;

  resourceTypes?: ResourceType[];
  resourceTypesFiltered?: ResourceType[];
  resourceTypesSubs!: Subscription;

  resourceTypeQuery: string = '';

  // User Story 6933: Locations Dropdowns are read-only; changes go through a feature request
  readOnly = true;

  constructor(
    protected override injector: Injector,
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.rsfSettings = this.rsfSettings?.filter(s => s.type == RSFSettingType.ResourceTypes);
    this.loadResourceTypes();
    this.setValues();
  }

  loadResourceTypes() {
    this.resourceTypesSubs = this.store.select(state => state.ResourceTypes.data).subscribe((data: ResourceType[]) => {
      if (data?.length) {
        this.resourceTypes = data.filter(rt => rt.location);
        this.resourceTypesFiltered = this.resourceTypes;
      }
    });
  }

  setValues() {
    this.resourceTypesSettings = [];
    this.rsfSettings?.forEach(s => {
      const value = this.utils.JSONparse(s.defaultValue) as RSFResourceTypesSetting;
      const rt = {
        id: s.id,
        name: value?.name ?? s.name,
        description: value?.description ?? s.description,
        type: s.type,
        order: value?.order,
        resourceTypes: value?.resourceTypes,
        conditions: value?.conditions,
        disabled: true
      } as RSFRoleNotificationSetting;
      this.resourceTypesSettings?.push(rt);
    });
    this.resourceTypesSettings.sort((a, b) => this.utils.sort(a.order, b.order));
  }

  addNew() {
    this.resourceTypesSettings?.push({ id: 0, disabled: false, type: RSFSettingType.ResourceTypes });
  }

  drop(event: CdkDragDrop<RSFResourceTypesSetting[]>) {
    if (this.resourceTypesSettings) {
      moveItemInArray(this.resourceTypesSettings, event.previousIndex, event.currentIndex);
      this.reorderAndSaveArray();
    }
  }

  reorderAndSaveArray() {
    var number = 0;
    this.resourceTypesSettings?.forEach(r => {
      r.order = number;
      number++;
    });
    this.save();
  }

  save() {
    const settings: RSFSettings[] = [];
    this.resourceTypesSettings?.forEach(n => {
      const s = {
        id: n.id,
        name: n.name,
        description: n.description,
        conditions: n.conditions,
        type: n.type,
        defaultValue: this.utils.JSONstringify(n)
      } as RSFSettings;
      settings.push(s);
    });
    this.changed.emit(settings);
  }

  cancel(r: RSFResourceTypesSetting) {
    if (r.id && this.tmpResourceTypeSetting) {
      // restore the temporary setting into the list if it exists
      const idx = this.resourceTypesSettings?.findIndex(x => x.id === this.tmpResourceTypeSetting?.id) ?? -1;
      if (idx > -1 && this.resourceTypesSettings) {
        this.resourceTypesSettings[idx] = this.tmpResourceTypeSetting;
        this.resourceTypesSettings[idx].disabled = true;
      }
      this.tmpResourceTypeSetting = null;
    }
    else if (!r.id) {
      // remove the newly added (unsaved) item from the array
      const i = this.resourceTypesSettings?.findIndex(x => x === r) ?? -1;
      if (i > -1 && this.resourceTypesSettings) {
        this.resourceTypesSettings.splice(i, 1);
      }
    }
  }

  filterResourceTypes(event: any) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.resourceTypesFiltered = this.resourceTypes?.filter(rt => rt.name?.toLowerCase().includes(filterValue));
  }

  onResourceTypeSelected(s: RSFResourceTypesSetting, e: any) {
    const resourceType: ResourceType = e.option.value;
    if (!s.resourceTypes) {
      s.resourceTypes = [];
    }
    // prevent duplicates
    if (!s.resourceTypes.find((rt: ResourceType) => rt.id === resourceType.id)) {
      s.resourceTypes.push(resourceType);
      this.resourceTypeQuery = '';
      this.resourceTypesFiltered = this.resourceTypes?.filter(rt => rt.id !== resourceType.id);
    }
  }

  remove(s: RSFResourceTypesSetting, resourceType: ResourceType): void {
    const index = s.resourceTypes?.indexOf(resourceType) ?? -1;

    if (index >= 0) {
      s.resourceTypes?.splice(index, 1);
    }
  }
}
